export var TEAM_ACCOUNT_PAYMENT_METHOD;
(function (TEAM_ACCOUNT_PAYMENT_METHOD) {
    TEAM_ACCOUNT_PAYMENT_METHOD["UNKNOWN"] = "UNKNOWN";
    TEAM_ACCOUNT_PAYMENT_METHOD["DEFAULT_CARD"] = "DEFAULT_CARD";
    TEAM_ACCOUNT_PAYMENT_METHOD["INVOICING"] = "INVOICING";
})(TEAM_ACCOUNT_PAYMENT_METHOD || (TEAM_ACCOUNT_PAYMENT_METHOD = {}));
export var TEAM_ACCOUNT_COUNTRY_CODE;
(function (TEAM_ACCOUNT_COUNTRY_CODE) {
    TEAM_ACCOUNT_COUNTRY_CODE["UNSPECIFIED"] = "UNSPECIFIED";
    TEAM_ACCOUNT_COUNTRY_CODE["US"] = "US";
    TEAM_ACCOUNT_COUNTRY_CODE["CA"] = "CA";
    TEAM_ACCOUNT_COUNTRY_CODE["AU"] = "AU";
})(TEAM_ACCOUNT_COUNTRY_CODE || (TEAM_ACCOUNT_COUNTRY_CODE = {}));
